<template>
  <div :class="['form-input', { 'has-error': hasError }]">
    <label v-if="label" :for="id">{{ label }}</label>
    <select v-model="selected" :id="id" :class="{ disabled: disabled }">
      <option
        v-if="placeholder"
        :value="null"
        disabled="disabled"
        selected="selected"
        hidden
      >
        {{ placeholder }}
      </option>
      <option
        v-for="(option, index) in options"
        :key="index"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<script>
/*
セレクトボックスコンポーネント
[props]
  * value: v-modelでバインドされる要素
  * id: 要素のid。ラベル付与に必須
  * options: 選択肢の配列。各選択肢は以下のフォーマットで指定する
    - { label:（表示用の値, value:（バインドされた要素に渡る値）}
  * label: セレクトボックス上部に付与されるラベル(未指定の場合非表示)
  * placeholder: セレクトボックス未選択時に表示される値(未指定の場合はoptionsの先頭の要素が初期選択される)
*/
export default {
  name: "ItemSelectBox",
  props: {
    value: {
      type: Object,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
      validator(options) {
        return (
          options.length > 0 &&
          options.every((val) => {
            return ["label", "value"].every((key) => {
              return Object.keys(val).includes(key);
            });
          })
        );
      },
    },
    label: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    hasError: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    selected: {
      get() {
        if (this.value === null || typeof this.value === "undefined") {
          // 値未指定時
          if (this.placeholder) {
            // placeholderがある場合 => placeholderを表示
            return null;
          } else {
            // placeholderがない場合 => 選択肢の最初の要素を表示
            return typeof this.options[0].value;
          }
        } else {
          // 値指定時
          return this.value;
        }
      },
      set(selected) {
        this.$emit(
          "input",
          this.options.find((option) => option.value === selected).value
        );
      },
    },
    disabled() {
      return this.selected === null;
    },
  },
};
</script>

<style lang="scss" scoped></style>
